<template>
  <b-card>
    <!-- Tabs with card integration -->
    <b-row
      ><b-col lg="12">
        <b-tabs v-model="tabIndex">
          <b-tab :title="$t('edu_programs.welcome_message')">
            <b-card class="border mb-0">
              <b-form-group
                id="input-group-29"
                :label="$t('edu_programs.welcome_message')"
                label-for="input-29"
              >
                <b-form-input
                  id="input-29"
                  v-model="welcome.title"
                  type="text"
                  :placeholder="$t('edu_programs.welcome_message')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-30"
                :label="$t('edu_programs.explanation')"
                label-for="input-30"
              >
                <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                  v-model="welcome.description"
                  :placeholder="$t('edu_programs.explanation')"
                />
              </b-form-group>
              <hr />
              <b-row>
                <b-col lg="6">
                  <b-button block variant="primary" @click="submit(welcome)">
                    <i class="fa fa-plus" /> {{ $t("site.save") }}
                  </b-button>
                </b-col>
                <b-col lg="6">
                  <b-button block  @click="goToTable()" variant="success">
                    <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-tab>
          <b-tab title=" youtube فيديو تعريفى">
            <b-card class="border mb-0">
              <b-form-group
                id="input-group-29"
                label="youtube فيديو تعريفى"
                label-for="input-29"
              >
                <b-form-input
                  id="input-29"
                  v-model="youtube.title"
                  type="text"
                  :placeholder="$t('edu_programs.welcome_message')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-30"
                :label="$t('edu_programs.explanation')"
                label-for="input-30"
              >
                <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                  v-model="youtube.description"
                  :placeholder="$t('edu_programs.explanation')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-29"
                label="youtube فيديو تعريفى"
                label-for="input-29"
              >
                <b-form-input
                  id="input-29"
                  v-model="youtube.data"
                  type="text"
                  :placeholder="$t('edu_programs.welcome_message')"
                />
              </b-form-group>
              <hr />
              <b-row>
                <b-col lg="6">
                  <b-button block variant="primary" @click="submit(youtube)">
                    <i class="fa fa-plus" /> {{ $t("site.save") }}
                  </b-button>
                </b-col>
                <b-col lg="6">
                  <b-button block  @click="goToTable()" variant="success">
                    <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-tab>
          <b-tab title="   فيديو تعريفى">
            <b-card class="border mb-0">
              <b-form-group
                id="input-group-29"
                label=" فيديو تعريفى"
                label-for="input-29"
              >
                <b-form-input
                  id="input-29"
                  v-model="video.title"
                  type="text"
                  :placeholder="$t('edu_programs.welcome_message')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-30"
                :label="$t('edu_programs.explanation')"
                label-for="input-30"
              >
                <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                  v-model="video.description"
                  :placeholder="$t('edu_programs.explanation')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-29"
                label=" فيديو تعريفى"
                label-for="input-29"
              >
                <b-form-file
                  v-model="video.file"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                />
              </b-form-group>
              <hr />
              <b-row>
                <b-col lg="6">
                  <b-button block variant="primary" @click="submit(video)">
                    <i class="fa fa-plus" /> {{ $t("site.save") }}
                  </b-button>
                </b-col>
                <b-col lg="6">
                  <b-button block  @click="goToTable()" variant="success">
                    <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-tab>
          <b-tab title="ملف صوتي تعريفي">
            <b-card class="border mb-0">
              <b-form-group
                id="input-group-29"
                label=" ملف صوتي تعريفي"
                label-for="input-29"
              >
                <b-form-input
                  id="input-29"
                  v-model="sound.title"
                  type="text"
                  :placeholder="$t('edu_programs.welcome_message')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-30"
                :label="$t('edu_programs.explanation')"
                label-for="input-30"
              >
                <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                  v-model="sound.description"
                  :placeholder="$t('edu_programs.explanation')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-29"
                label=" ملف صوتي تعريفي"
                label-for="input-29"
              >
                <b-form-file
                  v-model="sound.file"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                />
              </b-form-group>
              <hr />
              <b-row>
                <b-col lg="6">
                  <b-button block variant="primary" @click="submit(sound)">
                    <i class="fa fa-plus" /> {{ $t("site.save") }}
                  </b-button>
                </b-col>
                <b-col lg="6">
                  <b-button block  @click="goToTable()" variant="success">
                    <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-tab>
          <b-tab title="ملف pdf تعريفي">
            <b-card class="border mb-0">
              <b-form-group
                id="input-group-29"
                label=" ملف pdf تعريفي"
                label-for="input-29"
              >
                <b-form-input
                  id="input-29"
                  v-model="file.title"
                  type="text"
                  :placeholder="$t('edu_programs.welcome_message')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-30"
                :label="$t('edu_programs.explanation')"
                label-for="input-30"
              >
                <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                  v-model="file.description"
                  :placeholder="$t('edu_programs.explanation')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-29"
                label="ملف pdf تعريفي"
                label-for="input-29"
              >
                <b-form-file
                  v-model="file.file"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                />
              </b-form-group>
              <hr />
              <b-row>
                <b-col lg="6">
                  <b-button block variant="primary" @click="submit(file)">
                    <i class="fa fa-plus" /> {{ $t("site.save") }}
                  </b-button>
                </b-col>
                <b-col lg="6">
                  <b-button block  @click="goToTable()" variant="success">
                    <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Auth from "@/Apis/Auth";
import EduProgramsController from "@/Controllers/EduProgramsController";
export default {
  data() {
    return {
      tabIndex: 0,
      eduProgram: {},
      welcome: { type: "welcome" },
      youtube: { type: "youtube" },
      video: { type: "video" },
      sound: { type: "sound" },
      file: { type: "file" },
    };
  },
  async created() {
    let eduProgram = await new EduProgramsController().Details(
      this.$route.params.eduProgramId
    );

    let welcome = eduProgram.details.find((a) => a.type == "welcome");
    let youtube = eduProgram.details.find((a) => a.type == "youtube");
    let video = eduProgram.details.find((a) => a.type == "video");
    let sound = eduProgram.details.find((a) => a.type == "sound");
    let file = eduProgram.details.find((a) => a.type == "file");
    if (welcome) this.welcome = welcome;
    if (youtube) this.youtube = youtube;
    if (video) this.video = video;
    if (sound) this.sound = sound;
    if (file) this.file = file;
  },
  methods: {
    async submit(data) {
      data.typeView = "publishing_settings_details";
      data.edu_program_id = this.$route.params.eduProgramId;
      await new EduProgramsController().AddEduProgramDetails(data);
    },
  },
};
</script>

<style>
</style>